import React, { Component } from 'react';
import './style.scss';
import config from '../../../../../../../../config';
import SocketContext from '../../../../../../../../SocketContext';
import { SketchPad, TOOL_PENCIL, TOOL_ERASER } from '../../../../../../../../components/SketchPad';
import classNames from 'classnames';
import {cloneDeep} from 'lodash';
import ColorInput from './components/ColorInput';
import SizeInput from './components/SizeInput';
import { isBlockedSpiner } from '../../../../../../../../actions';
import { connect } from 'react-redux'
import Draggable from 'react-draggable';
import Dimensions from 'react-dimensions'
import { I18n } from 'react-redux-i18n';

class Image extends Component {
  constructor(props) {
    super(props)
    this.refCursore = React.createRef();
    this.refEl = React.createRef();
    this.refCanvas = React.createRef();
    this.refImgContainer = React.createRef();
    this.timeResize = null;

    const sketch_show = localStorage.getItem('sketch_show') && localStorage.getItem('sketch_show') == 'true' || false;

    this.state = {
      pointre: {
        show: false,
      },
      sketch: {
        show: sketch_show,
        show_whire_board: false,
        width: 0,
        widthSketchTeacher: 0,
        heightSketchTeacher: 0,
        height: 0,
        tool:TOOL_PENCIL,
        size: 3,
        scalePoint: 1,
        color: 'rgba(0,0,0,1)',
        fill: false,
        fillColor: '#444444',
        defaultItems: props.slide.sketch && props.slide.sketch.defaultItems || [],
        items: props.slide.sketch && props.slide.sketch.items || [],
        items_white_board: props.slide.sketch && props.slide.sketch.items_white_board || [],
        visible_white_board: false,
        visible_img_board: true,
      }
    }
  }

  componentDidMount(){
    const {io} = this.context;
    const {is_logined, presentation, slide_id, heightSlideItems} = this.props;


    window.setSizeImage = this.setSizeImage;

    io.socket.on('mouse_change', (data) => {
      if(this.refCursore.current){

        let elPos = this.getCoords(this.refEl.current);

        let clientHeight = this.refEl.current.clientHeight;
        let clientWidth = this.refEl.current.clientWidth;

        let x = data.x/(data.clientWidth/clientWidth);
        let y = data.y/(data.clientHeight/clientHeight);

        let h = 0;

        let header = document.getElementById('header');

        if(header){
          h = header.clientHeight;
        }
        
        this.refCursore.current.style.top = (elPos.top + y - (27 + h)) + 'px';
        this.refCursore.current.style.left = (elPos.left + x - 7) + 'px';
      }
    });

    io.socket.on('pointer_show_status', (item) => {
      this.setState({pointre: {
        show: item,
      }})
    });

    io.socket.on('get_pointer_show_status', (item) => {
      if(is_logined){
        io.socket.request({
          method: 'post',
          url: '/api/auth/socket_message',
          data: {
            presentation_id: presentation.id, 
            type: 'pointer_show_status',
            data: this.state.pointre.show
          }
        });
      }      
    });

    io.socket.on('sketch_change', ({item, duration}) => {
      const {sketch} = this.state;
      const {is_logined} = this.props;
      if(is_logined){
        this.props.isBlockedSpiner(false);
      }


      const items = [
        ...sketch.items, 
        // item
      ]
      const items_white_board = [
        ...sketch.items_white_board, 
        // item
      ]

      if(sketch.show_whire_board){
        items_white_board.push(item)
      } else {
        items.push(item)
      }
      


      this.setState({
        sketch: {
          ...sketch,
          items,
          items_white_board
        }
      });

      this.props.setSketch({
        slide_id: this.props.slide_id,
        sketch: {
          ...sketch,
          items,
          items_white_board
        }
      })
    });

    
    io.socket.on('sketch_data', (sketch) => {
      if(!sketch){
        return
      }
      this.state.sketch.items = sketch.items;
      this.state.sketch.items_white_board = sketch.items_white_board;
      this.state.sketch.show_whire_board = sketch.show_whire_board;
      this.state.sketch.visible_img_board = !sketch.show_whire_board;
      this.state.sketch.visible_white_board = sketch.show_whire_board;
      const {heightSlideItems} = this.props;
      this.setSizeImage(heightSlideItems);

    });


    io.socket.on('change_white_board', (status) => {
      this.changeSketchState({show_whire_board: status})

      setTimeout(() => {
        this.changeSketchState({
          visible_img_board: !status,
          visible_white_board: status,
        })
      }, 200);

    })

    io.socket.on('get_sketch_data', (item) => {
    
      if(is_logined){
        io.socket.request({
          method: 'post',
          url: '/api/auth/socket_message',
          data: {
            presentation_id: presentation.id, 
            type: 'sketch_data',
            data: this.state.sketch
          }
        });
      }      
    });

    window.addEventListener("resize", this.resizeWindow);

    window.addEventListener("message", this.receiveMessage, false);

    this.setSizeImage(heightSlideItems);

    if(is_logined && (this.state.sketch.items.length || this.state.sketch.items_white_board.length)){
      io.socket.request({
        method: 'post',
        url: '/api/auth/socket_message',
        data: {
          presentation_id: this.props.presentation.id, 
          type: 'sketch_data',
          data: this.state.sketch
        }
      });
    }

  }


  setSizeImage = (heightSlideItems) => {
    const {slide} = this.props;

    let header = document.getElementById('header');


    let img = document.createElement('img');
    img.src = config.siteUrl + slide.src;


    let header_h = 0

    if(header){
      header_h = header.clientHeight; 
    }
    
    if(this.refEl.current){
      let widthContainer = this.refImgContainer.current.clientWidth;
      this.refEl.current.style = {};
      this.refEl.current.style.height = `calc(100vh - ${heightSlideItems + header_h + 20}px)`;

      if(this.refEl.current.clientHeight > img.naturalHeight){
        this.refEl.current.style.height = img.naturalHeight + 'px';
      }
      
      if(widthContainer < this.refEl.current.clientWidth){
        this.refEl.current.style = {};
        this.refEl.current.style.width = widthContainer + 'px';
      }
      

      const currentW = this.refEl.current.clientWidth;
      const currentH = this.refEl.current.clientHeight;
      const scale = Math.max(currentH / img.naturalHeight, currentW / img.naturalWidth);  
      if(this.refCanvas.current && this.refCanvas.current.ctx){
        if(this.refCanvas.current.canvasRef){
          this.refCanvas.current.canvasRef.width = currentW;
          this.refCanvas.current.canvasRef.height = currentH;
          
        }        
      }

      const {sketch} = this.state;

      let tmp_items = cloneDeep(sketch.items)
      let tmp_items_white_board = cloneDeep(sketch.items_white_board)
 
      this.setState({
        sketch: {
          ...sketch,
          width: this.refEl.current.clientWidth,
          height: this.refEl.current.clientHeight,
          items: [],
          items_white_board: [],
        }
      }, () => {
        if(this.refCanvas.current && this.refCanvas.current.ctx){
          this.refCanvas.current.ctx.scale(scale, scale);
          this.refCanvas.current.ctx.clearRect(0, 0, currentW, currentH);
        }
        this.setState({
          sketch: {
            ...this.state.sketch,
            items: tmp_items,
            items_white_board: tmp_items_white_board,
          }
        })
      })
    }
  }

  getScalePoint = () => {
    let scale = 1;
    const {slide} = this.props;
    const {sketch} = this.state;
    let img = document.createElement('img');
    img.src = config.siteUrl + slide.src;
    
    scale = Math.max(img.naturalHeight/sketch.height || 1, img.naturalWidth/sketch.width || 1);

    return scale;
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.resizeWindow);
    window.addEventListener("message", this.receiveMessage, false);
  }

  receiveMessage = (event) => {
    if(event.data.hasOwnProperty('appHeaderEvent')){
      const {heightSlideItems} = this.props;
      this.setSizeImage(heightSlideItems);
    }
  }



  resizeWindow = () => {
    const {heightSlideItems} = this.props;
    this.setSizeImage(heightSlideItems);
  }


  getCoords(elem) {
    // (1)
    var box = elem.getBoundingClientRect();
  
    var body = document.body;
    var docEl = document.documentElement;
  
    // (2)
    var scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
    var scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;
  
    // (3)
    var clientTop = docEl.clientTop || body.clientTop || 0;
    var clientLeft = docEl.clientLeft || body.clientLeft || 0;
  
    // (4)
    var top = box.top + scrollTop - clientTop;
    var left = box.left + scrollLeft - clientLeft;
  
    return {
      top: top,
      left: left
    };
  }

  mouseChange = (e) => {
    
    const {slide, is_logined} = this.props; 
    const {pointre} = this.state;

    if(!is_logined || !pointre.show){
      return
    }
    const {io} = this.context;
    const {presentation} = this.props;
    let data = this.getCoords(this.refEl.current);

    const clientX = e.clientX || e.touches[0] && e.touches[0].clientX;
    const clientY = e.clientY || e.touches[0] && e.touches[0].clientY;

    let x = clientX-data.left;
    let y = clientY-data.top;
    console.log("🚀 ~ file: index.jsx:352 ~ Image ~ x:", x, y, e)

    io.socket.request({
      method: 'post',
      url: '/api/auth/socket_message',
      data: {
        presentation_id: presentation.id, 
        type: 'mouse_change',
        data: {x, y, clientHeight: this.refEl.current.clientHeight, clientWidth: this.refEl.current.clientWidth}
      }
    }, (body, response) => {

    });
  }

  sketchChange = (item) => {
    try {
      const {slide, is_logined} = this.props; 
      const {sketch} = this.state;
      if(!is_logined){
        return
      }

      if(!sketch.show){
        return
      }
      const {io} = this.context;
      const {presentation} = this.props;
      
      const widthSketchTeacher = this.refEl.current.clientWidth;
      const heightSketchTeacher = this.refEl.current.clientHeight;

      this.props.isBlockedSpiner(true);

      io.socket.request({
        method: 'post',
        url: '/api/auth/socket_message',
        data: {
          presentation_id: presentation.id,
          type: 'sketch_change',
          data: {
            item, 
            duration:{
              widthSketchTeacher,
              heightSketchTeacher,
            }
          }
        }
      }, (body, response) => {

      });
    } catch (error) {
      
    }
  }

  toggletPointer = (status) => {
    const {io} = this.context;
    const {presentation} = this.props;

    if(status){
      this.toggletSketchPad(false);
    }
    if(this.props.setIsDrawPaint){
      this.props.setIsDrawPaint(status)
    }
    io.socket.request({
      method: 'post',
      url: '/api/auth/socket_message',
      data: {
        presentation_id: presentation.id, 
        type: 'pointer_show_status',
        data: status
      }
    });
  }

  toggletSketchPad = (status) => {
    if(status){
      this.toggletPointer(false)
    }

    if(this.props.setIsDrawPaint){
      this.props.setIsDrawPaint(status)
    }

    const {sketch} = this.state;

    localStorage.setItem('sketch_show', status)
    this.setState({
      sketch: {
        ...sketch, 
        show: status,
      }
    });
  }

  componentWillReceiveProps(nextProps){
    console.log("componentWillReceiveProps -> nextProps", nextProps)
    const {sketch} = this.state;
    const {is_logined, presentation} = nextProps;
    if(nextProps.heightSlideItems != this.props.heightSlideItems){
      this.setSizeImage(nextProps.heightSlideItems);
    }

    if(nextProps.slide_id != this.props.slide_id){
      this.state.sketch.items = []
      this.state.sketch.items_white_board = []
      if(nextProps.slide.sketch){
        this.state.sketch.items = nextProps.slide.sketch.items;
        this.state.sketch.items_white_board = nextProps.slide.sketch.items_white_board;
        if(is_logined){
          const {io} = this.context;
          io.socket.request({
            method: 'post',
            url: '/api/auth/socket_message',
            data: {
              presentation_id: presentation.id, 
              type: 'sketch_data',
              data: this.state.sketch
            }
          });
        }
      }
      this.setSizeImage(nextProps.heightSlideItems);
    }
  }

  changeSketchState = (data) => {
    const {sketch} = this.state;
    this.setState({sketch: {
      ...sketch,
      ...data
    }})
  }

  clearBoard = () => {
    const {is_logined, presentation} = this.props;
    if(is_logined){
      const {io} = this.context;

      if(this.state.sketch.show_whire_board){
        this.state.sketch.items_white_board = [];
      } else {
        this.state.sketch.items = [];
      }
      // this.state.sketch.items_white_board = []
      io.socket.request({
        method: 'post',
        url: '/api/auth/socket_message',
        data: {
          presentation_id: presentation.id, 
          type: 'sketch_data',
          data: this.state.sketch
        }
      });
    }
  }

  isMobile(){
    const test = navigator.userAgent||navigator.vendor||window.opera;
    var isiPad = test.match(/iPad/i) !== null;
    var isTablet = test.match(/(android|tablet|kindle)/i) !== null && !isiPad;
    var isMobile = !isTablet && test.match(/(android|iphone|ipod)/i) !== null;

    return isiPad || isTablet || isMobile;
    var check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
    return check;
  }

  render() {
    const {slide, is_logined, presentation, heightSlideItems} = this.props;
    const {sketch, pointre} = this.state;
    const {io} = this.context;

    let horizont = false;


    const {visible_img_board, visible_white_board, show_whire_board} = sketch;

    if(heightSlideItems < 30){
      horizont = true;
    }    
    const isMobile = this.isMobile();
    return (
      <div className="Image" ref={this.refImgContainer}>
        {is_logined && !sketch.show && <div className={classNames("action-slide-img", {horizont})}>
          <div className={classNames("item", {active: pointre.show})} onClick={() => {this.toggletPointer(!pointre.show)}}>
            <i className="fas fa-mouse"></i>
          </div> 
          <div className={classNames("item", {active: sketch.show})} onClick={() => this.toggletSketchPad(!sketch.show)}>
            <i className="fas fa-palette"></i>
          </div>
        </div>}

        {is_logined && sketch.show && 
        <Draggable handle="p">
          <div className={classNames("action-slide-img", {horizont})}>
            <p className="move-p"></p>
            <div className={classNames("item")} onClick={() => this.toggletSketchPad(!sketch.show)}>
              <i className="fas fa-times"></i>
            </div>
            <div className={classNames("item", {active: sketch.tool == TOOL_PENCIL})} onClick={() => {this.changeSketchState({tool:TOOL_PENCIL })}}>
              <i className="fas fa-pencil-alt"></i>
            </div>
            
            <div className={classNames("item", {active: sketch.tool == TOOL_ERASER})} onClick={() => {this.changeSketchState({tool:TOOL_ERASER })}}>
              <i className="fas fa-eraser"></i>
            </div>

            <div className={classNames("item")} title={I18n.t('titleClearBoard')} onClick={() => {
              this.clearBoard();
            }}>
              <i className="fas fa-ban"></i>
            </div>
            
            {sketch.tool != TOOL_ERASER && <ColorInput color={sketch.color} onChangeColor={(color) => {
              if(color.rgb){
                this.changeSketchState({color:`rgba(${color.rgb.r},${color.rgb.g},${color.rgb.b},${color.rgb.a})` })
              } else {
                this.changeSketchState({color:color.hex })
              }
            }} />}
            <SizeInput size={sketch.size} onChange={(size) => this.changeSketchState({size})} />
            <div className={classNames("item", {active: sketch.show_whire_board})} style={{marginTop: 10}} onClick={() => {
                // this.changeSketchState({show_whire_board: !this.state.sketch.show_whire_board })
                io.socket.request({
                  method: 'post',
                  url: '/api/auth/socket_message',
                  data: {
                    presentation_id: presentation.id, 
                    type: 'change_white_board',
                    data: !show_whire_board
                  }
                });
              }}>
                <i className="far fa-clipboard"></i>
            </div>
          </div>
        </Draggable>
        
        }

        {pointre.show && <div className="cursore-move" ref={this.refCursore}/>}  
          <div class={classNames("flip-card", {active: sketch.show_whire_board})} style={{width: sketch.width, height: sketch.height}}>
            <div class="flip-card-inner">
              <div class="flip-card-front">
                {visible_img_board && <div onMouseMove={isMobile ? ()  => {} : this.mouseChange} onTouchMove={!isMobile ? ()  => {} : this.mouseChange}>
                  <SketchPad
                    ref={this.refCanvas}
                    width={sketch.width}
                    height={sketch.height}
                    animate={false}
                    disabled={!is_logined || !sketch.show}
                    canvasClassName="SketchPad"
                    size={sketch.size}
                    color={sketch.color}
                    items={sketch.items}
                    tool={sketch.tool}
                    isMobile={isMobile}
                    onCompleteItem={(i) => this.sketchChange(i)}
                    scalePoint={this.getScalePoint()}
                  />
                  <img ref={this.refEl} src={config.siteUrl + slide.src} onLoad={() => {
                    const {heightSlideItems} = this.props;
                    this.setSizeImage(heightSlideItems);
                  }}/>
                </div>}
              </div>
              <div class="flip-card-back">
                {visible_white_board && <div  onMouseMove={isMobile ? ()  => {} : this.mouseChange} onTouchMove={!isMobile ? ()  => {} : this.mouseChange}>
                  <SketchPad
                    ref={this.refCanvas}
                    width={sketch.width}
                    height={sketch.height}
                    animate={false}
                    disabled={!is_logined || !sketch.show}
                    canvasClassName="SketchPad"
                    size={sketch.size}
                    color={sketch.color}
                    items={sketch.items_white_board}
                    tool={sketch.tool}
                    isMobile={isMobile}
                    onCompleteItem={(i) => this.sketchChange(i)}
                    scalePoint={this.getScalePoint()}
                  />
                  <img ref={this.refEl} src={config.siteUrl + slide.src} onLoad={() => {
                    const {heightSlideItems} = this.props;
                    this.setSizeImage(heightSlideItems);
                  }}/>
                  {/* <div className="white_board_bg"/> */}
                </div>}
              </div>
            </div>
          </div>

          
        {/* </div> */}
        
      </div>
    );
  }
}

Image.contextType = SocketContext;

const mapStateToProps = (state, ownProps) => ({
  
})

const mapDispatchToProps = {
  isBlockedSpiner
}

export default Dimensions()(connect(mapStateToProps, mapDispatchToProps)(Image))
